import { render } from "./myPlayList.vue?vue&type=template&id=07d5c4fb&scoped=true"
import script from "./myPlayList.vue?vue&type=script&lang=js"
export * from "./myPlayList.vue?vue&type=script&lang=js"

import "./myPlayList.vue?vue&type=style&index=0&id=07d5c4fb&scoped=true&lang=css"
import "./myPlayList.vue?vue&type=style&index=1&id=07d5c4fb&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d5c4fb"]])

export default __exports__